
define('app/users/pwreset/pwResetApp',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/pwResetModel',
	'unknown/views/pwResetView'
], function($, _, Backbone, PwResetModel, PwResetView){
	var initialize = function(){
		var pwResetModel = new PwResetModel();
		var pwResetView = new PwResetView({pwResetModel: pwResetModel});
		pwResetView.render();
	};
	
	return {
		initialize: initialize
	};
});